import { rating as ratingData, procedureGameContent, stubContent, oldRating } from './copyright'
import Preloader from '../components/pages/preloader/Preloader'
import Error from '../components/pages/error/Error'
import Start from '../components/pages/start'
import Info from '../components/pages/info/Info'
import { Rules } from '../components/pages/rules'
import Games from '../components/scenes/games/Games'
import Task from '../components/pages/task/main/Task'
import Roadmap from '../components/pages/roadmap/Roadmap'
import Gifts from '../components/pages/gifts/Gifts'
import Customization from '../components/pages/customization/Customization'
import Match3 from '../components/scenes/match3/Match3'
import Platformer from '../components/scenes/platformer/Platformer'
import CreatingPerson from '../components/pages/creatingPerson/CreatingPerson'
import Quiz from '../components/pages/quiz/Quiz'
import Friends from '../components/pages/friends'
import Memories from '../components/scenes/memories/Memories'
import { Sets } from '../components/pages/sets'
import ProcedureGame from '../components/pages/procedureGame/ProcedureGame'
import GameRating from '../components/pages/gameRating/GameRating'
import Wheel from '../components/pages/wheel/Wheel'
import Stub from '../components/pages/stub/Stub'
import InteractiveShop from '../components/pages/interactiveShop'
import { Shelf } from '../components/pages/shelf'
import { Shop } from '../components/pages/shop'
import Raffle from '../components/pages/raffle/Raffle'
import NyTask from '../components/pages/nyTask/NyTask'
import Main from '../components/pages/main'
import { Rating } from '../components/pages/rating'
import { OldRating } from '../components/pages/old-rating'
import Challenges from '../components/pages/challenges'
import { CHALLENGES, ROADMAP, WISH /*, YEAR_STAT, GUESS_PRISE*/ } from './shared/states/names'
import Wish from '../components/pages/wish'
// import GuessPrice from '../components/scenes/price';
// import YearStat from '../components/pages/yearStat';
import Doodle from '../components/scenes/doodle/Doodle'
import Share from '../components/pages/share'

export const appContent = {
  preloader: {
    Component: Preloader,
  },
  share: {
    Component: Share,
  },
  error: {
    Component: Error,
  },
  start: {
    Component: Start,
  },
  info: {
    Component: Info,
  },
  rating: {
    Component: Rating,
    props: ratingData,
  },
  oldRating: {
    Component: OldRating,
    props: oldRating,
  },
  [ROADMAP]: {
    Component: Roadmap,
  },
  gifts: {
    Component: Gifts,
  },
  games: {
    Component: Games,
  },
  quiz: {
    Component: Quiz,
  },
  friends: {
    Component: Friends,
  },
  match3: {
    Component: Match3,
  },
  jumper: {
    Component: Doodle,
  },
  platform: {
    Component: Platformer,
  },
  memories: {
    Component: Memories,
  },
  rules: {
    Component: Rules,
  },
  creating: {
    Component: CreatingPerson,
  },
  main: {
    Component: Main,
  },
  task: {
    Component: Task,
  },
  customization: {
    Component: Customization,
  },
  sets: {
    Component: Sets,
  },
  procedureGame: {
    Component: ProcedureGame,
    props: procedureGameContent,
  },
  gameRating: {
    Component: GameRating,
  },
  wheel: {
    Component: Wheel,
  },
  [WISH]: {
    Component: Wish,
  },
  interactiveShop: {
    Component: InteractiveShop,
  },
  shelf: {
    Component: Shelf,
  },
  shop: {
    Component: Shop,
  },
  raffle: {
    Component: Raffle,
  },
  nyTask: {
    Component: NyTask,
  },
  stub: {
    Component: Stub,
    props: stubContent,
  },
  [CHALLENGES]: {
    Component: Challenges,
  },
  // [YEAR_STAT]: {
  //   Component: YearStat,
  // },
  // [GUESS_PRISE]: {
  //   Component: GuessPrice,
  // },
}
